import cmp from './IndustriesDialog'

export default cmp
